// getSavedHotelBrand — pure resolver for a user's saved hotel loyalty brand.
//
// Extracted verbatim from `AIChatBot.js` (module-level `getSavedHotelBrand`) as
// part of the behavior-preserving refactor (issue #240). Returns the user's
// `hotelLoyaltyBrand`, then `preferredHotelBrand`, else `null`.
//
// React-free and side-effect-free. Total over malformed input via optional
// chaining: a missing/`null` profile yields `null`, matching the source.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Resolves the saved hotel brand from a user profile.
 *
 * @param {Object|null|undefined} userProfile - The user profile (may be missing).
 * @returns {string|null} The saved brand, or `null` when none is set.
 */
export function getSavedHotelBrand(userProfile) {
  return userProfile?.hotelLoyaltyBrand || userProfile?.preferredHotelBrand || null;
}

export default getSavedHotelBrand;
